module.exports = __webpack_public_path__ + "img/Sun.67c87aa7.png";